import * as React from 'react';
import CustomerForm from '@pages/customers/form';
import CompanyForm from '@pages/company/form';
import { closeModal, setModalContent } from '@components/modal';
import { translate } from '@data/translations';
import { CompanyModel, CustomerModel } from '@common/modelDefinition';
import { Reservation /* ReservationController */ } from '../resController';
import { searchCustomer, searchCompany } from '../api';
import { ReactComponent as Edit } from '../../../assets/custom/icons/edit.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/custom/icons/trash.svg';
import { ReactComponent as NewIcon } from '../../../assets/custom/icons/plus.svg';

var searchDebouncer: NodeJS.Timeout = setTimeout(() => {}, 0);

interface CustomersAndCompaniesInterface {
    customer: CustomerModel | null;
    company: CompanyModel | null;
    history: any;
    customerSelect: (customer: CustomerModel) => void;
    companySelect: (company: CompanyModel) => void;
    docScanner?: boolean;
    showCompany?: boolean;
    //className?: string;
    customerOrCompanyInvalid?: boolean;
    deleteCompany?: (company: CompanyModel) => void;
    deleteCustomer?: (customer: CustomerModel) => void;
    reservation?: Reservation;
    editCustomer?: (customer: CustomerModel) => void;
    editCompany?: (company: CompanyModel) => void;
    doNotShowCustomerSearch?: boolean;
    flexColumn?: boolean;
    dontShowCreateCompany?: boolean;
    width?: string;
    customerCompanyStyle?: any;
}

const CustomersAndCompanies = (props: CustomersAndCompaniesInterface) => {
    const { customerSelect, companySelect, docScanner = false, customerCompanyStyle } = props;
    const {
        history,
        company,
        // className,
        customer,
        customerOrCompanyInvalid = false,
        showCompany = true,
        reservation = null,
        flexColumn,
        dontShowCreateCompany,
    } = props;

    // const ctrl = new ReservationController();

    const [customers, setCustomers] = React.useState<CustomerModel[]>([]);
    const [companies, setCompanies] = React.useState<CompanyModel[]>([]);
    const [customerSearch, setCustomerSearch] = React.useState('');
    const [companySearch, setCompanySearch] = React.useState('');

    const onCustomerSearch = (e: any) => {
        clearTimeout(searchDebouncer);
        const searchString = e.target.value;
        setCustomerSearch(searchString);
        searchDebouncer = setTimeout(async () => {
            const result = await searchCustomer(searchString);
            setCustomers(result);
            if (companySearch !== '') {
                setCompanies([]);
                setCompanySearch('');
            }
        }, 500);
    };

    const onCompanySearch = (e: any) => {
        clearTimeout(searchDebouncer);
        const searchString = e.target.value;
        setCompanySearch(searchString);
        searchDebouncer = setTimeout(async () => {
            const result = await searchCompany(searchString);
            setCompanies(result);
            if (customerSearch !== '') {
                setCustomers([]);
                setCustomerSearch('');
            }
        }, 500);
    };

    const onSelectCompany = (company: CompanyModel) => {
        companySelect(company);
        setCompanies([]);
        setCompanySearch('');
    };

    const onSelectCustomer = (customer: CustomerModel) => {
        customerSelect(customer);
        setCustomers([]);
        setCustomerSearch('');
    };

    const addCompany = () => {
        setModalContent(
            <CompanyForm
                history={history}
                callback={(company: CompanyModel) => {
                    companySelect(company);
                    setCompanies([]);
                    setCompanySearch('');
                }}
                customHeader={' '}
                cancelHandler={() => {}}
                showPageTitle={false}
            />,
            translate('Company'),
            false,
            'modal-lg'
        );
    };

    const addCustomer = () => {
        setModalContent(
            <CustomerForm
                history={history}
                callback={(customer: CustomerModel) => {
                    customerSelect(customer);
                    setCustomerSearch('');
                    setCustomers([]);
                }}
                customHeader={' '}
                cancelHandler={() => closeModal()}
                showPageTitle={false}
                reservation={reservation}
            />,
            translate('Guest'),
            false,
            'modal-lg'
        );
    };

    const comapniesSearchResult = companies.map((c: CompanyModel, index: number) => {
        return (
            <div key={'c' + c.id + index} className="customers-companies-list" onClick={() => onSelectCompany(c)}>
                <div className="customer-list-icon" style={{ height: '32px' }}>
                    <i className="fa fa-building " aria-hidden="true"></i>
                </div>

                <div className="customer-list-data">
                    <div className="display-flex align-items-center">
                        {' '}
                        <div className="text-bold mr-8p font-14p">{c.name}</div>
                        <div className="font-12p">{c.idNumber ? '(' + c.idNumber + ')' : ''}</div>
                    </div>
                    <div className="display-flex font-12p">
                        {c.address}
                        {c.address && c.town ? ', ' : ''} {c.town}
                    </div>
                </div>
            </div>
        );
    });

    const customersSearchResult = customers.map((c: CustomerModel, index: number) => {
        return (
            <div key={'c' + c.id + index} className="customers-companies-list" onClick={() => onSelectCustomer(c)}>
                <div className="customer-list-icon">
                    <i className="fa fa-user " aria-hidden="true"></i>
                </div>

                <div className="customer-list-data">
                    <div className="display-flex align-items-center">
                        {' '}
                        <div className="text-bold mr-8p font-14p">
                            {c.firstName || '-'} {c.lastName || '-'}
                        </div>
                        <div className="font-12p">{c.documentId ? '(' + c.documentId + ')' : ''}</div>
                    </div>
                    <div className="display-flex font-12p">{c.email}</div>
                </div>
            </div>
        );
    });

    let inputFieldCss = ' input input-modal ';

    if (showCompany && customerOrCompanyInvalid) {
        inputFieldCss = inputFieldCss + ' is-invalid';
    }

    return (
        <div className="w-100">
            <div className={'display-flex  ' + (flexColumn ? ' flex-column ' : ' align-items-center ')}>
                {props.doNotShowCustomerSearch ? null : (
                    <div
                        className={'flex  ' + (flexColumn ? ' mb-8p ' : ' mr-4p ')}
                        style={customerCompanyStyle ? customerCompanyStyle : {}}
                    >
                        {customer ? (
                            <div className="display-flex align-items-center">
                                <div
                                    className="mr-4p ml-4p"
                                    style={{ fontSize: '14px', fontWeight: 'bold', color: '#1068ec' }}
                                >{`${customer.firstName} ${customer.lastName}`}</div>
                                {props.editCustomer ? (
                                    <div
                                        className="button-white-w-icon-only"
                                        onClick={() => {
                                            setModalContent(
                                                <CustomerForm
                                                    callback={(updatedCustomer: CustomerModel) => {
                                                        if (props.editCustomer) {
                                                            props.editCustomer(updatedCustomer);
                                                        }
                                                    }}
                                                    cancelHandler={() => closeModal()}
                                                    customerId={customer.id}
                                                    reservation={reservation}
                                                />,
                                                translate('Edit customer'),
                                                false,
                                                'modal-lg'
                                            );
                                        }}
                                    >
                                        <Edit />
                                    </div>
                                ) : null}
                                {props.deleteCustomer ? (
                                    <div
                                        className="button-white-w-icon-only fill-red"
                                        onClick={() => {
                                            if (props.deleteCustomer) {
                                                props.deleteCustomer(customer);
                                            }
                                        }}
                                    >
                                        <DeleteIcon />
                                    </div>
                                ) : null}
                            </div>
                        ) : (
                            <div className="display-flex align-items-center p-1">
                                <div className={docScanner ? ' flex ' : ' flex '}>
                                    <input
                                        value={customerSearch}
                                        onChange={onCustomerSearch}
                                        className={inputFieldCss}
                                        type="text"
                                        placeholder={translate('SEARCH CUSTOMERS')}
                                    />
                                </div>
                                <div className={''}>
                                    <div
                                        onClick={(e) => {
                                            e.preventDefault();
                                            addCustomer();
                                        }}
                                        className={'button-white-w-icon-only fill-primary'}
                                    >
                                        <NewIcon />
                                    </div>
                                </div>
                            </div>
                        )}
                        {customersSearchResult.length > 0 ? (
                            <div
                                className="customers-and-company-search-result shadow-sm"
                                style={{ minWidth: props.width ? props.width : '300px' }}
                            >
                                {customersSearchResult}
                            </div>
                        ) : null}
                    </div>
                )}
                {showCompany ? (
                    <div
                        className={'flex  ' + (flexColumn ? '' : ' ml-4p')}
                        style={customerCompanyStyle ? customerCompanyStyle : {}}
                    >
                        {company ? (
                            <div className="flex-center ">
                                <div className="ml-4p mr-4p flex-center flex-wrap" style={{ color: '#1068ec' }}>
                                    <div
                                        className=""
                                        style={{ fontSize: '14px', fontWeight: 'bold', color: '#1068ec' }}
                                    >
                                        {company.name}{' '}
                                    </div>{' '}
                                    {flexColumn ? (
                                        <div className="flex-center ml-8p" style={{ fontSize: '12px' }}>
                                            {company.address} {company.town}
                                        </div>
                                    ) : null}
                                </div>
                                {props.editCompany ? (
                                    <div
                                        className="button-white-w-icon-only"
                                        onClick={() => {
                                            setModalContent(
                                                <CompanyForm
                                                    callback={(updatedCompany: CompanyModel) => {
                                                        if (props.editCompany) {
                                                            props.editCompany(updatedCompany);
                                                        }
                                                    }}
                                                    companyId={company.id}
                                                />,
                                                translate('Edit company'),
                                                false,
                                                'modal-lg'
                                            );
                                        }}
                                    >
                                        <Edit />
                                    </div>
                                ) : null}
                                {props.deleteCompany ? (
                                    <div
                                        className="button-white-w-icon-only fill-red"
                                        onClick={() => {
                                            if (props.deleteCompany) {
                                                props.deleteCompany(company);
                                            }
                                        }}
                                    >
                                        <DeleteIcon />
                                    </div>
                                ) : null}
                            </div>
                        ) : (
                            <div className="display-flex align-items-center p-1">
                                <div className="flex">
                                    <input
                                        value={companySearch}
                                        onChange={onCompanySearch}
                                        className={inputFieldCss}
                                        type="text"
                                        placeholder={translate('SEARCH COMPANIES')}
                                    />
                                </div>
                                {dontShowCreateCompany ? null : (
                                    <div className="">
                                        <div onClick={addCompany} className={'button-white-w-icon-only fill-primary'}>
                                            <NewIcon />
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                        {showCompany && comapniesSearchResult.length > 0 ? (
                            <div
                                className="customers-and-company-search-result shadow-sm"
                                style={{ minWidth: props.width ? props.width : '300px' }}
                            >
                                {showCompany ? comapniesSearchResult : null}
                            </div>
                        ) : null}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export { CustomersAndCompanies };
